import Vue from "vue";
import BigNumber from "bignumber.js";


const registerGlobalComponents = () => {
  // Lazy-loaded components
  Vue.component("PatientProfile", () => import("@/components/PatientProfile"));

  // Error handling components
  Vue.component("ErrorBoundary", () => import("@/components/ErrorBoundary"));

  BigNumber.set({ DECIMAL_PLACES: 2, ROUNDING_MODE: BigNumber.ROUND_DOWN });
};

export default registerGlobalComponents;